import type React from 'react';
import { useEffect } from 'react';

import { useProgress } from '@/context/progress';
import { useAmlQuestionnaireProgressStep } from '@/features/onboarding/aml-questionnaire/hooks/use-progress-step';
import BaseLayout from '@/layouts/base';

const AmlQuestionnaireLayout = (props: React.ComponentPropsWithoutRef<typeof BaseLayout>) => {
  const { setCurrentStep } = useProgress();
  const progressStep = useAmlQuestionnaireProgressStep();

  useEffect(() => {
    return setCurrentStep(progressStep);
  }, [progressStep, setCurrentStep]);

  return <BaseLayout {...props} />;
};
AmlQuestionnaireLayout.displayName = 'AmlQuestionnaireLayout';

export default AmlQuestionnaireLayout;
